import type { DayCol } from "./build-days.js";
import { TimeAxisGrid } from "./TimeAxisGrid.js";

interface Props {
  /** WIDE, stable day window (visible + buffer columns). */
  days: DayCol[];
  windowStart: Date;
  visibleStart: Date;
  visibleCount: number;
  onDayShift?: (delta: number) => void;
  onDayCountChange?: (delta: number) => void;
}

export function WeekGrid({ days, windowStart, visibleStart, visibleCount, onDayShift, onDayCountChange }: Props) {
  return (
    <TimeAxisGrid
      days={days}
      windowStart={windowStart}
      visibleStart={visibleStart}
      visibleCount={visibleCount}
      {...(onDayShift ? { onDayShift } : {})}
      {...(onDayCountChange ? { onDayCountChange } : {})}
    />
  );
}
